import { ReactElement } from "react"
import { Wrapper } from "../wrapper/wrapper"
import { PriceProps } from "./price-props"
import * as S from './price-style'

export function Price ({ id, values }: PriceProps): ReactElement {
  return <S.Container id={id}>
    <Wrapper>
      <S.Display>
        <S.Price>Consultas no clínico geral a partir de <span>R$ {values.general}</span></S.Price>
        <S.Price>Demais áreas médicas a partir de <span>R$ {values.specialist}</span></S.Price>
      </S.Display>
    </Wrapper>
  </S.Container>
}